var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"back-button my-2 p-2",attrs:{"size":"sm","block":""},on:{"click":function($event){return _vm.$router.push('/home')}}},[_c('b-icon',{staticClass:"mr-2",attrs:{"icon":"house-fill"}}),_c('span',[_vm._v("Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }